interface WebsterEntryProps {
  englishWord: string;
  definition: string | null;
  isMissing: boolean;
}

/** Webster's 1828 entry for the tapped English word (the panel's Webster's tab). */
export function WebsterEntry({ englishWord, definition, isMissing }: WebsterEntryProps) {
  return (
    <div className="strongs-webster-section">
      <h4 className="strongs-webster-title">WEBSTER&apos;S 1828</h4>
      {definition ? (
        <p className="strongs-webster-text">
          <span className="strongs-webster-word">{englishWord.toUpperCase()}</span>
          {definition}
        </p>
      ) : (
        <p className="strongs-webster-text italic text-stone-500 dark:text-stone-400">
          {isMissing
            ? <>No dictionary entry for &ldquo;{englishWord}&rdquo;</>
            : <>Looking up &ldquo;{englishWord}&rdquo;&hellip;</>}
        </p>
      )}
    </div>
  );
}
